import apiClient from './apiClient.js';
import * as utils from '../utils/utils.js';

export const createGathering = async (gathering) => {
    const session_url = '/gathering';
    try {
        const response = await apiClient.post(session_url, {
            gathering: gathering,
        });

        if (response.status === 201) {
            utils.saveLastCreatedUuid(response.data.gathering_id);
        }

        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
